import {Component, Module} from 'app/decorators';
import tpl from './presets.html';


@Module({
    name: "app.tickets.component.presets",

})
@Component({
    selector: 'blnd-presets',
    bindings: {
        presets: '=',
    },
    template: tpl,
})
export default class C {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/tickets/components/presets.js